import React, { useState } from "react";
import { trackPromise } from 'react-promise-tracker';
import { apiCall } from '../utils/apiUtils';
import PhaseProgress from './PhaseProgress';

const API_CALL_TRACKER_AREA = 'api-call';

const PHASE_PRESETS = {
  trend_topic: [
    'Analyzing your trend...',
    'Crafting your headline...',
    'Polishing content...',
  ],
  default: [
    'Preparing your request...',
    'Generating content...',
    'Almost there...',
  ],
};

function getPhases(promptType) {
  return PHASE_PRESETS[promptType] || PHASE_PRESETS.default;
}

function ApiCallButton({ iData, onResponse, url, secret, promptType, label, value, originalKeyword, brandVoiceSettings }) {
  const [isLoading, setIsLoading] = useState(false);

  let prompt = {}
  prompt[promptType] = iData
  if (originalKeyword) {
    prompt['key_word'] = originalKeyword
  }

  if (brandVoiceSettings) {
    Object.assign(prompt, brandVoiceSettings);
  }

  async function handleApiCall() {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const rData = await trackPromise(
        apiCall(url, JSON.stringify(prompt), {
          headers: {
            "x-functions-key": secret
          }
        }),
        API_CALL_TRACKER_AREA
      );
      onResponse(rData, iData);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return (
      <div className="apiCallButton apiCallButton--loading">
        <PhaseProgress phases={getPhases(promptType)} isActive={isLoading} />
      </div>
    );
  }

  return (
    <div className="apiCallButton">
      <button onClick={() => handleApiCall()}>
        <div className="button-flip-container">
          <div className="button-flip-front">
            <div className="button-content">
              <span className="button-label">{label || iData}</span>
              {value && <span className="button-value">{value}</span>}
            </div>
          </div>
          <div className="button-flip-back">
            <svg width="28" height="28" viewBox="0 0 24 24" className="confirm-icon" fill="#fff">
            <path d="M20.292 5.292a1 1 0 010 1.414l-11 11a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L9 15.586 18.878 5.708a1 1 0 011.414 0z"/>
          </svg>
          </div>
        </div>
      </button>
    </div>
  );
}

export default ApiCallButton;
